import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_35vnge4tj4: FaireBrandEntity = {
  token: "b_35vnge4tj4",
  type: "brand",
  name: "Ani’s Market LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/0a98e2106cae9f958f26fa428faee77631ede362c9964fb275de3880e7d3a23c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7b58ae7d8638a466d7efb93ba554973f310030dae56b7135a06dce9324d5f22d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0a98e2106cae9f958f26fa428faee77631ede362c9964fb275de3880e7d3a23c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7b58ae7d8638a466d7efb93ba554973f310030dae56b7135a06dce9324d5f22d.jpeg",
  location: "Clarksville, TN, USA",
  minimumOrderDollars: 118,
  rating: 5,
  reviewCount: 108,
  isTopShop: true,
  isInsider: true,
  description:
    "Ani’s Market is a US-made aromatherapy bath and body brand specializing in shower steamers, essential oil rollers, and bath soaks designed for everyday self-care and gifting. Our products combine clean ingredients, bold scent experiences, and eye-catching presentation that drives impulse purchases and repeat sales.\n\nFounded with a focus on accessible wellness, Ani’s Market creates high-performing aromatherapy products that deliver real sensory impact without the need for a bath. Our shower steamers are especially popular as giftable, problem-solving items — from sinus relief to stress support — making them strong sellers across boutiques, spas, pharmacies, and specialty retail.\n\nAll products are produced in the United States and packaged retail-ready with UPCs and compliant labeling. We design with merchandising in mind, offering countertop displays and seasonal assortments that maximize shelf visibility and turnover.\n\nAni’s Market is committed to quality, consistency, and building long-term retail partnerships.\n\nFeel free to reach out:\nIrena Nikolowa\nCall/Text: [redacted-phone]\nEmail: [redacted-email]\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:06.691Z",
    importedBy: "entity-db-cli",
  },
};
